export default {
      id: "demarches_associations-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#demarches_associations-usage",
      toString: function () {
        return this.url;
      }
    }